// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hcAR","rootMobile":"styles_rootMobile__1yi9W"};